import React, { Fragment } from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import StarRatingComponent from 'react-star-rating-component';
import { COLOR_SELECTOR } from 'app/constants/Constants';
import * as stringUtils from 'app/utils/StringUtils';

const SurveyBanner = (transactionName) => (
    <div className="survey-banner survey-banner-v2">
        <div className="container">
            <h1>
                Rate your experience with the counterparties in execution of transaction <span>{transactionName}</span>
            </h1>
        </div>
    </div>
);
const Rating = ({ input: { name, value, onChange } }) => (
    <StarRatingComponent
        name={name}
        value={value}
        renderStarIcon={(index, v) => (
            <span>
                <i className={index <= v ? 'icon-star-fill' : 'icon-star-empty'} />
            </span>
        )}
        onStarClick={(nextValue) => onChange(nextValue)}
    />
);

const renderRatings = ({ fields }) => (
    <Fragment>
        {fields.map((Attr, index) => (
            <li key={index}>
                <div>
                    <p>{fields.get(index).name}</p>
                    <Field name={`${Attr}.rating`} component={Rating} />
                    <strong className="one-value">Beware!</strong>
                    <strong className="two-value">Hmm... not so good</strong>
                    <strong className="three-value">Just okay</strong>
                    <strong className="four-value">Pretty good</strong>
                    <strong className="five-value">Superb!</strong>
                </div>
            </li>
        ))}
    </Fragment>
);

const renderSurveyFields = ({ fields }) => (
    <Fragment>
        {fields.map((counterParty, index) => (
            <div key={index} className="survey-detail">
                <h2>
                    {fields.get(index).logoUrl ? (
                        <CompanyLogo logoUrl={fields.get(index).logoUrl} />
                    ) : (
                        <CompanyInitial index={index} companyName={fields.get(index).companyName} />
                    )}
                    {fields.get(index).companyName}
                    <sub>{stringUtils.humanize(fields.get(index).type)}</sub>
                </h2>
                <ul className="list-inline sur-det">
                    <FieldArray name={`${counterParty}.qualityAttributes`} component={renderRatings} />
                </ul>
            </div>
        ))}
    </Fragment>
);

const CompanyLogo = ({ logoUrl }) => (
    <span>
        <img alt="" src={logoUrl} />
    </span>
);

const CompanyInitial = ({ index, companyName }) => (
    <span className={`initial ${COLOR_SELECTOR[index % COLOR_SELECTOR.length]}`}>{companyName.charAt(0)}</span>
);

const SurveyForm = (props) => {
    const { initialValues, handleSubmit, submitting } = props;
    return (
        <form onSubmit={handleSubmit}>
            <div>
                {SurveyBanner(initialValues.transactionName)}
                <div className="survey survey-v2 survey-v3">
                    <div className="container">
                        <h1>
                            Rate your experience - <span>{initialValues.transactionName}</span>
                        </h1>
                        <div className="survey-list">
                            <FieldArray name="counterParties" component={renderSurveyFields} />
                            <div className="text-right">
                                <button type="submit" disabled={submitting}>
                                    {submitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

SurveyForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
};

export default reduxForm({
    form: 'survey',
})(SurveyForm);
